import { render } from "./install.vue?vue&type=template&id=229b48fb&scoped=true"
import script from "./install.vue?vue&type=script&lang=js"
export * from "./install.vue?vue&type=script&lang=js"

import "./install.vue?vue&type=style&index=0&id=229b48fb&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229b48fb"]])

export default __exports__